
// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Divider from "@mui/material/Divider";
// import Popper from "@mui/material/Popper";
// import Paper from "@mui/material/Paper";
// import Collapse from "@mui/material/Collapse";
// import Box from "@mui/material/Box";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
// import AnalyticsRoundedIcon from "@mui/icons-material/AnalyticsRounded";
// import PersonIcon from "@mui/icons-material/Person";
// import ReceiptIcon from "@mui/icons-material/Receipt";
// import PaymentIcon from "@mui/icons-material/Payment";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import { useNavigate } from "react-router-dom";
// import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import BusinessIcon from '@mui/icons-material/Business';
// import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
// import EventIcon from '@mui/icons-material/Event';
// import StarIcon from '@mui/icons-material/Star';
// import BookOnlineIcon from '@mui/icons-material/BookOnline';
// import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
// import GroupIcon from '@mui/icons-material/Group';
// import SecurityIcon from '@mui/icons-material/Security';
// import { yellow } from "../../styles/ThemePrimitives";
// import MenuBase from "./MenuBase"; // Base component to handle rendering logic
// import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
// import  { useUser } from "../../contexts/UserContext";

// const MenuContentCoordinator = ({ open }) => {
//   const {user} = useUser();
//   // console.log("User", user)
//   const menuItems = [
//     {
//       label: "Dashboard",
//       icon: <HomeRoundedIcon />,
//       path: "/dashboard",
//     },
//     {
//       label: "Mumeneen",
//       icon: <PersonIcon />,
//       path: "/mumeneen",
//     },
//     {
//       label: "Accounts",
//       icon: <AnalyticsRoundedIcon />,
//       subOptions: [
//         { label: "Receipts", path: "/receipts", icon: <ReceiptIcon /> },
//         { label: "Payments", path: "/payments", icon: <PaymentIcon /> },
//         // { label: "Expenses", path: "/expenses", icon: <AttachMoneyIcon /> },
//                 ...(user?.id === 473
//           ? [{ label: "Expenses", path: "/expenses", icon: <AttachMoneyIcon /> }]
//           : []),

//       ],
//     },
//     // {
//     //   label: "Groupings",
//     //   icon: <PeopleRoundedIcon />,
//     //   subOptions: [
//     //     { label: "Sector", path: "/sector", icon: <ApartmentIcon /> },
//     //     { label: "Sub-Sector", path: "/sub_sector", icon: <BusinessIcon /> },
//     //     { label: "Transfers", path: "/transfers", icon: <TransferWithinAStationIcon /> },
//     //   ],
//     // },
//                 {
//           label: "Niyaz Calendar",
//           icon: <EventIcon />,
//           path: "/niyaz-calendar",
//         },

//     // {
//     //   label: "Bookings",
//     //   icon: <EventIcon />,
//     //   subOptions: [
//     //     { label: "Zabihat", path: "/zabihat", icon: <StarIcon /> },
//     //     { label: "Salawat/Fateha", path: "/salawat_fateha", icon: <StarIcon /> },
//     //     { label: "Niyaz Date", path: "/niyaz_date", icon: <BookOnlineIcon /> },
//     //   ],
//     // },

//     // {
//     //   label: "Notifications",
//     //   icon: <NotificationsIcon />,
//     //   path: "/notifications",
//     // },
//     // {
//     //   label: "Settings",
//     //   icon: <SettingsRoundedIcon />,
//     //   path: "/settings",
//     // },
//     // {
//     //   label: "User Management",
//     //   icon: <AdminPanelSettingsIcon />,
//     //   subOptions: [
//     //     // { label: "Roles", path: "/roles", icon: <GroupIcon /> },
//     //     { label: "User Access", path: "/user_access", icon: <SecurityIcon /> },
//     //   ],
//     // },
//   ];

//   return <MenuBase open={open} menuItems={menuItems} />;
// };

// export default MenuContentCoordinator;




import React, { useState } from "react";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AnalyticsRoundedIcon from "@mui/icons-material/AnalyticsRounded";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentIcon from "@mui/icons-material/Payment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useNavigate } from "react-router-dom";
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BusinessIcon from '@mui/icons-material/Business';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import EventIcon from '@mui/icons-material/Event';
import StarIcon from '@mui/icons-material/Star';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';
import { yellow } from "../../styles/ThemePrimitives";
import MenuBase from "./MenuBase"; // Base component to handle rendering logic
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useUser } from "../../contexts/UserContext";
import { hasPermission, canShowNiyazCalendarRegardlessOfAccess, canShowLqCollection, canShowDueList } from "../../util";

const MenuContentCoordinator = ({ open }) => {
  const { user, permissions, accessRoleId, roles } = useUser();
  const isCoordinator = accessRoleId === 4;
  const canShowNiyazCalendar = canShowNiyazCalendarRegardlessOfAccess(user);
  
  // Ensure permissions is an array and we have roles loaded
  const effectivePermissions = Array.isArray(permissions) ? permissions : [];
  
  // Don't render menu if we don't have proper role/permission data
  if (!isCoordinator || !Array.isArray(roles) || roles.length === 0) {
    return null;
  }

  // Define all menu items with their permission requirements
  const allMenuItems = [
    {
      label: "Dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
      permission: "dashboard_widgets", // Optional check, but always show if coordinator
      alwaysShow: true, // Always show for coordinator
    },
    {
      label: "Mumeneen",
      icon: <PersonIcon />,
      path: "/mumeneen",
      permission: "mumeneen",
    },
    {
      label: "Accounts",
      icon: <AnalyticsRoundedIcon />,
      permission: null, // Parent doesn't need permission
      subOptions: [
        { label: "Receipts", path: "/receipts", icon: <ReceiptIcon />, permission: "receipts" },
        { label: "Payments", path: "/payments", icon: <PaymentIcon />, permission: "payments" },
        { label: "Expenses", path: "/expenses", icon: <AttachMoneyIcon />, permission: "expense" },
      ],
    },
    {
      label: "Groupings",
      icon: <PeopleRoundedIcon />,
      permission: null, // Parent doesn't need permission
      subOptions: [
        { label: "Sector", path: "/sector", icon: <ApartmentIcon />, permission: "sector" },
        { label: "Sub-Sector", path: "/sub_sector", icon: <BusinessIcon />, permission: "sub_sector" },
        { label: "Transfers", path: "/transfers", icon: <TransferWithinAStationIcon />, permission: "transfer" },
      ],
    },
    {
      label: "Contributions",
      icon: <EventIcon />,
      permission: null, // Check for bookings/contributions permission
      subOptions: [
        { label: "Zabihat", path: "/zabihat", icon: <StarIcon /> },
        { label: "Salawat/Fateha", path: "/salawat_fateha", icon: <StarIcon /> },
        { label: "⁠Extra Niyaz in Faiz Thaali", path: "/extra_niyaz_in_faiz_thaali", icon: <StarIcon /> },
        { label: "Miqaat Niyaz", path: "/miqaat_niyaz", icon: <StarIcon /> },
        { label: "Contribution receipts", path: "/contribution_receipts", icon: <ReceiptLongIcon /> },
      ],
    },
    {
      label: "Niyaz Calendar",
      icon: <EventIcon />,
      path: "/niyaz-calendar",
      permission: "niyaz_calendar", // Require explicit permission
    },
    {
      label: "LQ Collection",
      icon: <ReceiptIcon />,
      path: "/lq-collection",
      lqCollectionOnly: true, // Shown only for allowed user IDs
    },
    {
      label: "Due List",
      icon: <PaymentIcon />,
      path: "/due-list",
      dueListOnly: true,
    },
    {
      label: "Hierarchy",
      icon: <AccountTreeIcon />,
      path: "/masool_hierarchy",
      permission: "hierarchy", // Require explicit permission
    },
    {
      label: "Menu",
      icon: <RestaurantMenuIcon />,
      path: "/menu",
      permission: "menu",
    },
    {
      label: "Feedback",
      icon: <HelpRoundedIcon />,
      path: "/feedback",
      permission: "feedback",
    },
    {
      label: "User Management",
      icon: <AdminPanelSettingsIcon />,
      permission: null, // Parent doesn't need permission
      subOptions: [
        { label: "User Access", path: "/user_access", icon: <SecurityIcon /> },
      ],
    },
  ];

  // Filter menu items based on permissions
  const filteredMenuItems = allMenuItems
    .map(item => {
      // Handle items with subOptions
      if (item.subOptions) {
        // Show Contributions only for specific username/ITS.
        if (item.label === "Contributions") {
          const userNameOrIts = String(user?.username ?? user?.its ?? "");
          return userNameOrIts === "40413333" || userNameOrIts === "40413682" ? item : null;
        }
        
        // Filter sub-options based on permissions
        const filteredSubs = item.subOptions.filter(sub => {
          // If sub-option has no permission requirement, show it
          if (!sub.permission) return true;
          // Check if user has permission for this sub-option
          return hasPermission(effectivePermissions, sub.permission);
        });
        
        // Only show parent if there are visible sub-options
        return filteredSubs.length > 0 ? { ...item, subOptions: filteredSubs } : null;
      }
      
      // Handle single items (no subOptions)
      // For Dashboard: check dashboard_widgets permission if available, otherwise always show for coordinator
      if (item.label === "Dashboard") {
        if (item.permission && hasPermission(effectivePermissions, item.permission)) {
          return item; // Has dashboard_widgets permission
        }
        // If no dashboard_widgets permission but is coordinator, show anyway
        return isCoordinator && item.alwaysShow ? item : null;
      }
      
      // For items with alwaysShow flag, show if coordinator
      if (item.alwaysShow && isCoordinator) {
        return item;
      }
      
      // Niyaz Calendar: show for allowed user ids (regardless of permission) or if user has niyaz_calendar permission
      if (item.path === "/niyaz-calendar") {
        return canShowNiyazCalendar || hasPermission(effectivePermissions, "niyaz_calendar") ? item : null;
      }

      // LQ Collection: show only for allowed user IDs (40413682, 40413333)
      if (item.path === "/lq-collection" || item.lqCollectionOnly) {
        return canShowLqCollection(user) ? item : null;
      }

      if (item.path === "/due-list" || item.dueListOnly) {
        return canShowDueList(user) ? item : null;
      }
      
      // If item has permission requirement, check it
      if (item.permission) {
        return hasPermission(effectivePermissions, item.permission) ? item : null;
      }
      
      // If no permission requirement and no alwaysShow, don't show
      return null;
    })
    .filter(Boolean); // Remove null items

  return <MenuBase open={open} menuItems={filteredMenuItems} />;
};

export default MenuContentCoordinator;

